import React from 'react';
import styled from '@emotion/styled';
import {
    color_shades_darkest,
    voicify_spark_light,
    voicify_spark_lightest
} from '../../../../../shared/constants/colors';
import { MetricInfoTooltip } from './MetricInfoTooltip';

interface AppointmentSummaryMetricButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const AppointmentSummaryMetricButton: React.FC<AppointmentSummaryMetricButtonProps> = ({
    onClick,
    disabled = false,
    children
}) => disabled ? <div>{children}</div> : (
    <MetricInfoTooltip
        metricKey="OUTBOUND_APPOINTMENT_RESPONSE_RATE_HEALTHCARE"
        showCalculation={true}
        actionHint="Click to view breakdown"
        trigger={(
            <MetricButton
                type="button"
                onClick={onClick}
                aria-label="View outbound appointment success details"
            >
                {children}
            </MetricButton>
        )}
    />
);

const MetricButton = styled.button`
    display: block;
    position: relative;
    isolation: isolate;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${color_shades_darkest};
    cursor: pointer;
    font: inherit;
    text-align: right;

    &::before {
        content: '';
        position: absolute;
        inset: -6px -8px;
        z-index: -1;
        border-radius: 8px;
        background: transparent;
        transition: background 160ms ease;
    }

    &:hover::before,
    &:focus-visible::before {
        background: ${voicify_spark_lightest};
    }

    &:focus-visible {
        outline: 3px solid ${voicify_spark_light};
        outline-offset: 4px;
        border-radius: 4px;
    }
`;

export default AppointmentSummaryMetricButton;
